module.exports = __webpack_public_path__ + "img/prize_head.267866ac.png";